import { menuReportingGroupCardFactory } from './chunk-C5AX5WMK.mjs';
import { __spreadProps, __spreadValues } from './chunk-T36PI2YV.mjs';

// src/helpers/factories/mainScreenTables/menuReportingGroupsTableFactory.ts
var menuReportingGroupsTableFactoryCore = (reportingGroups, items, combos) => menuReportingGroupCardFactory(reportingGroups).map((reportingGroup) => {
  const menuReportingGroup = reportingGroups[reportingGroup.id];
  return __spreadProps(__spreadValues({}, reportingGroup), {
    itemCount: menuReportingGroup.itemIds.length,
    comboCount: menuReportingGroup.comboIds.length,
    combos: menuReportingGroup.comboIds.map((comboId) => {
      var _a, _b;
      return (_b = (_a = combos[comboId]) == null ? void 0 : _a.name) != null ? _b : comboId;
    }).join(", ") || void 0,
    items: menuReportingGroup.itemIds.map((itemId) => {
      var _a, _b;
      return (_b = (_a = items[itemId]) == null ? void 0 : _a.name) != null ? _b : itemId;
    }).join(", ") || void 0
  });
});

export { menuReportingGroupsTableFactoryCore };
